import React, { FC } from "react";
import { RecommendationTranslationProductDto } from "@green0meter/api-client";
import { useTranslation } from "react-i18next";

import { StyledCard } from "./Products.styled";

import {
  Card,
  CardContent,
  CardMedia,
  Divider,
  Box,
  Button,
  Grid,
  Stack,
  Typography,
} from "@components/base";

interface Component {
  products: RecommendationTranslationProductDto[];
}

const Component: FC<Component> = ({ products }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent>
        <Typography variant="h5">{t("products.chooseHelpful")}</Typography>
        <Box mt={3}>
          <Grid container spacing={2}>
            {products.map((product) => (
              <Grid size={4} key={product.title}>
                <StyledCard className={product.highlighted ? "highlighted" : ""}>
                  <Stack justifyContent="space-between" height="100%">
                    <Box>
                      <CardMedia
                        sx={{ height: 204 }}
                        image={`https://gm-directus-app-dev.azurewebsites.net/assets/${product.image_id}`}
                      />
                      <Stack
                        p={3}
                        direction="column"
                        spacing={2}
                        justifyContent="space-between"
                      >
                        <Typography variant="h6" fontWeight={700} lineHeight="24px">
                          {product.title}
                        </Typography>
                        <Typography variant="body2">{product.text}</Typography>
                      </Stack>
                    </Box>
                    <Box px={3} pb={3}>
                      <Button fullWidth color="primary" variant="contained">
                        {t("products.interested")}
                      </Button>
                      {product.secondary_link_url && (
                        <Button
                          fullWidth
                          variant="outlined"
                          color="secondary"
                          href={product.secondary_link_url}
                          target="_blank"
                          component="a"
                        >
                          {product.secondary_link_title}
                        </Button>
                      )}
                    </Box>
                  </Stack>
                </StyledCard>
              </Grid>
            ))}
            <Grid size={12}>
              <Divider />
            </Grid>
            <Grid size={12}>
              <Typography
                variant="caption"
                textAlign="right"
                display="block"
                fontStyle="italic"
                color="#777"
              >
                {t("products.caption")}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Component;
